// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { excluirEmpreendimentosService } from "../../../services/excluirEmpreendimentoService";

export const useExcluirEmpreendimento = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [warning, setWarning] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);
  const resetWarning = () => setWarning(null);

  const excluirEmpreend = async (empreendId: number) => {
    setIsLoading(true);
    setError(null);

    try {
      const excluirEmpreendimento = await excluirEmpreendimentosService(
        empreendId
      );

      if (excluirEmpreendimento) {
        setSuccess("Empreendimento excluído com sucesso!");
      } else {
        setError(
          "Ocorreu um erro e não foi possível excluir o empreendimento!"
        );
      }
    } catch (error: any) {
      if (error.code === "FK_CONSTRAINT") {
        setWarning(error.message);
      } else {
        setError(
          error.message || "Ocorreu um erro ao excluir o empreendimento!"
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    excluirEmpreend,
    isLoading,
    error,
    success,
    warning,
    resetError,
    resetSuccess,
    resetWarning,
  };
};
